import { useUserSettings } from '@bpm-web-app/utils';
import { CustomIcon } from '../custom-icon/custom-icon';
import { SquaredButton } from '../squared-button/squared-button';

interface AddToFavoriteButtonProps {
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    hasTooltip?: boolean;
    isFavorite?: boolean;
    fullWidth?: boolean;
    squared?: boolean;
    isCreate?: boolean;
}

export function AddToFavoriteButton({ onClick, hasTooltip, isFavorite, fullWidth, squared, isCreate }: AddToFavoriteButtonProps) {
    const { isAnonymous, setShowSignUpModal } = useUserSettings();

    const handleOnClick = (e: React.MouseEvent<HTMLElement>) => {
        if (isAnonymous) {
            setShowSignUpModal({ type: isCreate ? 'pack' : 'track' });
            return;
        }
        if (onClick) onClick(e);
    };

    const resolvedLabel = isFavorite ? 'Remove' : 'Save';

    if (squared) {
        return <SquaredButton
            leftIcon={<CustomIcon type={isFavorite ? 'heart-filled-icon' : 'heart-outline-icon'} color="white" />}
            type="outline"
            label={resolvedLabel}
            onPress={handleOnClick}
            fullWidth={fullWidth} />;
    }

    if (hasTooltip) {
        return (
            <CustomIcon type={isFavorite ? 'heart-filled-icon' : 'heart-outline-icon'} hasIconHover onClick={handleOnClick} tooltip={resolvedLabel} hasBackgroundHover container="round" containerSize="regular" />
        );
    }

    return (
        <CustomIcon type={isFavorite ? 'heart-filled-icon' : 'heart-outline-icon'} hasIconHover onClick={handleOnClick} />
    );
}
